'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = exports.getArcLength = exports.getRelativeValue = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _glamor = require('glamor');

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 Calculation methods for the animaty stuff
*/

var getRelativeValue = exports.getRelativeValue = function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);

  return clampedValue / (max - min);
};

var getArcLength = exports.getArcLength = function getArcLength(fraction, size, width) {
  return fraction * Math.PI * (size - width);
};

/*
 consts used in anims
*/
var offset = 180;
var duration = '1.5s';

var spin = _glamor.css.keyframes('spin', {
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' }
});

var dash = _glamor.css.keyframes('dash', {
  '0%': {
    strokeDashoffset: offset,
    transform: 'rotate(0deg)'
  },
  '50%': {
    strokeDashoffset: offset / 4,
    transform: 'rotate(135deg)'
  },
  '100%': {
    strokeDashoffset: offset,
    transform: 'rotate(360deg)'
  }
});

/*
 styles
*/
var defaultStyle = exports.defaultStyle = {
  position: 'relative',
  display: 'inline-block',
  '& .wrapper': {
    transition: 'transform 20s linear'
  },
  '& .innerCircle': {
    strokeDasharray: offset,
    strokeDashoffset: 0,
    transformOrigin: 'center',
    transition: 'all 1.5s ease-in-out',
    animation: dash + ' ' + duration + ' infinite ease-in-out'
  },
  '& .SVG': {
    position: 'relative',
    animation: spin + ' ' + duration + ' infinite linear'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref) {
  var color = _ref.color,
      size = _ref.size;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _extends3.default)({
    width: size,
    height: size,
    '& .innerCircle': {
      stroke: color || (0, _objectResolvePath2.default)(theme, 'colors.tertiary') || 'teal'
    },
    '& .wrapper': {
      width: size,
      height: size
    },
    '& .SVG': {
      width: size,
      height: size
    }
  }, (0, _objectResolvePath2.default)(theme, 'Spinner.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Spinner/Spinner.style.js
// module id = 542
// module chunks = 0